import { withPrefix } from "gatsby";
import React, {
  FunctionComponent,
  MouseEvent,
  useContext,
  useState,
} from "react";
import Context from "../../context/Context";
import { AuthLinkProps } from "../interfaces";
import { StyledGatedModal } from "../styled";

const GatedLink: FunctionComponent<AuthLinkProps> = (props: any) => {
  const [modalState, setModalState] = useState(false);
  const data = useContext(Context);
  const { siteName } = data;

  const handleOnClick = (event: MouseEvent) => {
    event.preventDefault();
    setModalState(true);
    props.onClick();
  };

  return (
    <>
      <a
        onClick={handleOnClick}
        className={props.className}
        href={withPrefix(props.to)}
        target={props.target}
      >
        {props.children}
      </a>
      {modalState && (
        <StyledGatedModal
          open={modalState}
          onClose={() => setModalState(false)}
          className="gated-modal"
        >
          <div className="container">
            <h2>
              {siteName} {new Date().getFullYear()}
            </h2>
            <p>
              <span>{props.children} Coming Soon</span>
            </p>
            <button onClick={() => setModalState(false)}>OK</button>
          </div>
        </StyledGatedModal>
      )}
    </>
  );
};

export default GatedLink;
